const ContentSetting = 'ContentSetting';
const ButtonText = 'ButtonText';
const FeatureProducts = 'FeatureProducts';

const contentSetting = 'contentSetting';
const image = 'image';
const imageSetting = 'imageSetting';
const title = 'title';

const buttonThemeUuid = 'buttonThemeUuid';
const buttonText = 'buttonText';

const featuredProducts = 'featuredProducts';
const titleTextColor = 'titleTextColor';

export {
  ContentSetting,
  ButtonText,
  FeatureProducts,
  contentSetting,
  image,
  imageSetting,
  title,
  buttonThemeUuid,
  buttonText,
  featuredProducts,
  titleTextColor,
};
